var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"inputEl",class:_vm.class_input,attrs:{"type":"text","readonly":_vm.modo_calc !== 'percent'},domProps:{"value":_vm.displayValue},on:{"blur":_vm.onBlur,"input":_vm.onInput,"click":_vm.onFocus,"mousedown":function($event){$event.preventDefault();}}})
}
var staticRenderFns = []

export { render, staticRenderFns }